import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.127 1.877a3.159 3.159 0 0 0-4.37 0l-.96.96-7.319 7.32a.746.746 0 0 0-.221.53V14a.749.749 0 0 0 .75.75l3.31-.01a.749.749 0 0 0 .53-.22l7.32-7.31.96-.96a1.191 1.191 0 0 0 .1-.12 3.09 3.09 0 0 0-.1-4.253Zm-9.12 11.36-2.25.01V11l6.57-6.57 2.25 2.25Zm8.06-8.05-.43.43-2.25-2.25.43-.43a1.631 1.631 0 0 1 2.25 0 1.612 1.612 0 0 1 0 2.25Z';
const draw24px =
  'M20.15,3.81a3.78,3.78,0,0,0-5.24-.1l-.12.1L13.54,5.06,4,14.58a.75.75,0,0,0-.22.53v4.31a.76.76,0,0,0,.75.75H8.85a.75.75,0,0,0,.53-.22l9.47-9.47.06-.05.05-.06,1.19-1.19A3.79,3.79,0,0,0,20.15,3.81ZM8.54,18.66H5.29V15.42l8.77-8.77,3.24,3.24ZM19.09,8.11l-.72.72L15.13,5.59l.72-.72a2.29,2.29,0,0,1,3.24,3.24Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PencilIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'pencil'),
) as IconWithRender;

PencilIcon.displayName = 'PencilIcon';
PencilIcon.propTypes = Icon.propTypes;
PencilIcon.renderIcon = (props) => <PencilIcon {...props} />;
export default PencilIcon;
